export default __webpack_public_path__ + "static/media/tablePreview_4.069c9e6e.png";